"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmergencySavingsModuleChildPath = void 0;
exports.EmergencySavingsModuleChildPath = {
    gettingStarted: 'getting-started',
    checkAccounts: 'check-accounts',
    chooseTarget: 'choose-target'
};
